<form [formGroup]="form">
  <mat-accordion class="w-100">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <b>ITAS</b>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="fields">
        <mat-form-field class="form-fields-wrapper">
          <mat-label>Username</mat-label>
          <input matInput formControlName="username" />
          <mat-icon matSuffix>account_circle</mat-icon>
        </mat-form-field>

        <mat-form-field class="form-fields-wrapper">
          <mat-label>Password</mat-label>
          <input matInput type="password" formControlName="password" />
          <mat-icon matSuffix>lock</mat-icon>
        </mat-form-field>

        <mat-form-field class="form-fields-wrapper">
          <mat-label>Compagnia predefinita</mat-label>
          <compagnia-picker formControlName="compagnia"></compagnia-picker>
        </mat-form-field>

        <mat-form-field class="form-fields-wrapper">
          <mat-label>Stato incarico predefinito</mat-label>
          <stato-incarico-picker formControlName="statoDefault"></stato-incarico-picker>
        </mat-form-field>
      </div>

      <div>
        <div class="mat-form-field margin-bottom">
          <mat-slide-toggle formControlName="enabled" color="primary">
            Abilitato
          </mat-slide-toggle>
        </div>
        <div class="mat-form-field margin-bottom">
          <mat-slide-toggle formControlName="accettaIncarico" color="primary">
            Accetta incarichi automaticamente
          </mat-slide-toggle>
        </div>
      </div>

      <div class="col">
        <button mat-raised-button color="primary" class="mb-2" (click)="Salva()">
          Salva
        </button>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</form>
